import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _debounce from 'lodash.debounce';
import $ from 'jquery';

import Icon from '../icon';
import ResultList from './result-list';

class Search extends PureComponent {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.object),
    placeholder: PropTypes.string,
    notFoundMessage: PropTypes.string,
    loading: PropTypes.bool,
    maxItems: PropTypes.number,
    labelKey: PropTypes.string,

    onInput: PropTypes.func,
    onSelect: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  }

  static defaultProps = {
    results: [],
    placeholder: '',
    notFoundMessage: 'Keine Eintr�ge gefunden.',
    loading: false,
    maxItems: 5,
    labelKey: 'label',

    onInput: () => {},
    onSelect: () => {},
    onFocus: () => {},
    onBlur: () => {}
  }

  constructor(props) {
    super();

    this.state = {
      inputValue: '',
      selectedIndex: 0,
      error: null
    }
  }

  onKeyDown = (evt) => {
    const keyCode = evt.which || evt.keyCode;
    const { selectedIndex } = this.state;
    const { results } = this.props;

    if (keyCode === 40) {
      // arrow down
      evt.preventDefault();
      this.setState({ selectedIndex: Math.min(results.length - 1, selectedIndex + 1, this.props.maxItems) });
    }

    if (keyCode === 38) {
      // arrow up
      evt.preventDefault();
      this.setState({ selectedIndex: Math.max(0, selectedIndex - 1) });
    }
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    this.onItemSelected(this.state.selectedIndex);
  }

  onItemSelected = (index = 0) => {
    const result = this.props.results[index];
    this.refs.inputField.blur();

    if (!result) {
      return this.setState({ error: this.props.notFoundMessage });
    }

    this.setState({ results: [], inputValue: $(`<span>${result[this.props.labelKey]}</span>`).text(), selectedIndex: 0 });
    this.props.onSelect(result);
  }

  onInput = evt => {
    this.setState({
      inputValue: evt.target.value
    });

    this.props.onInput(evt.target.value);
  }

  onFocus = evt => {
    this.setState({ inputValue: '', error: null });
    this.props.onFocus();
  }

  reset = () => {
    this.setState({ inputValue: '', error: null });
  }

  render() {
    const iconType = this.props.loading ? 'loading' : 'search';
    const iconClasses = classnames({ spin: this.props.loading });

    return (
      <div className="search">
        <form onSubmit={this.onSubmit} className="search-input-form input-group">
          <input
            onInput={this.onInput}
            value={this.state.inputValue}
            type="text"
            className="input"
            placeholder={this.props.placeholder}
            onKeyDown={this.onKeyDown}
            ref="inputField"
            onFocus={this.onFocus}
            onBlur={this.props.onBlur}
          />
          <button type="submit" className="input-submit">
            <Icon className={iconClasses} type={iconType} />
          </button>
        </form>
        { this.state.error && <div className="search-error">{this.state.error}</div> }
        <ResultList
          results={this.props.results.slice(0, this.props.maxItems)}
          selectedIndex={this.state.selectedIndex}
          onSelect={this.onItemSelected}
          labelKey={this.props.labelKey}
        />
      </div>
    )
  }
}

export default Search;
